// @ts-strict-ignore
import * as React from 'react';
import { useTranslation } from 'common/i18n/hooks';
import { SelectTheme } from 'common/components/select/constants';
import { SelectReact } from 'common/components/select';
import { isCohortSegment, SegmentValue } from 'common/query-builder/query-block/segment-menu/types';
import { Segmentation } from 'common/types/reports/query';
import { getLabelForPropertyType } from 'common/report/util/properties';
import { getPropertyType, setPropertyType } from 'common/query-builder/query-entry-section/row-types/row-util';
import { PropertyType } from 'common/report/constants';
import { ButtonSize } from 'common/components/button/constants';
import { ControlBarAction, ControlBarActionItems } from '../constants';
import { isMultiAttributionSegmentation } from '../row-types/behavior/utils';

/**
 * Renders typecasting controls for a given Segmentation entry on filters or breakdowns
 */
export function TypecastSubitem(props: {
  value: SegmentValue;
  onTypeChange: (newValue: SegmentValue) => void;
  forFilter?: boolean;
  disabledTypes?: PropertyType[];
}) {
  if (!props.value || isCohortSegment(props.value) || isMultiAttributionSegmentation(props.value)) {
    return null;
  }
  const {
    t,
    print
  } = useTranslation();
  const segmentation = props.value as Segmentation;
  const fullType = getPropertyType(segmentation);
  return <>
      {fullType.type && fullType.type !== segmentation.propertyDefaultType && <div className='subitem-text'>
          <SelectReact className='subitem-select' theme={SelectTheme.QbSubitem} size={ButtonSize.Small} menuWidth={null} neverShowCaret label={t("query-builder.data-type.changed-to-type", {
        type: fullType.isList ? "**".concat(t("query-builder.data-type.list-of-type", {
          type: print(getLabelForPropertyType(fullType.type))
        }), "**") : "**".concat(print(getLabelForPropertyType(fullType.type)), "**")
      })} elref='typecastSubitem' sections={ControlBarActionItems[ControlBarAction.Typecast](fullType, {
        disabledTypes: props.disabledTypes
      }).subSections} onChange={(ev: CustomEvent) => {
        props.onTypeChange(setPropertyType(segmentation, ev.detail.item.value.toType, props.forFilter));
      }} />
        </div>}
    </>;
}